import React from 'react'
import { Button, Modal } from 'react-bootstrap'
import { useAtomValue, useSetAtom } from 'jotai'

import * as lib from '../../lib'
import * as state from '../../states'
import { IOfferSpend } from '../../types'
import * as helpers from '../../helpers'
import { NotSystemItems, ItemBox, IdBox, ModalBodyBox } from '../role'
import { Trans, useTranslation } from 'react-i18next'
import { ALL_LANG_KEY } from '../../types/lang'
import dt from 'dayjs'

type IOfferSpendRemoveModalProps = {
	item: IOfferSpend | null;
	show: boolean;
	onClose: () => void;
	onSave: () => void;
}

export const OfferSpendRemoveModal = (
	props: IOfferSpendRemoveModalProps
) => {
	const { t } = useTranslation()
	const tokens = useAtomValue(state.tokensAtom)
	const access = tokens?.access ?? null
	const setFetchIsLoading = useSetAtom(state.fetchIsLoadingAtom)

	const { item, show, onClose, onSave } = props

	if (!show) {
		return null
	}

	const onRemove = async () => {
		const uri: string = `offer/spend/${item?.id}`
		const method: string = 'DELETE'
		const params: lib.FetchOptions['params'] = {}
		const headers = lib.bearer(access)
		const options: lib.FetchOptions = { method, params, headers }

		try {
			setFetchIsLoading(state.turnOnLoader)
			await lib.fetching<void>(uri, options)
			onSave()
		} catch (error: unknown) {
			// TODO: pretty notification alert
			console.error(error)
		} finally {
			setFetchIsLoading(state.turnOffLoader)
		}
	}

	const renderSingleItem = () => {
		const at = item?.at ?? null
		const atLabel = dt.utc(at).isValid() ? dt.utc(at).format('L') : '-'

		const formatValue = helpers.formatAmount(item?.amount ?? '')
		const formatValueWithSeparator = helpers.thousandSeparator(formatValue)

		const itemLabel = `${t(ALL_LANG_KEY.offer_spend_list_table.column_date)}: "${atLabel}", ${t(ALL_LANG_KEY.offer_spend_list_table.column_amount)}: "${formatValueWithSeparator}"`

		return (
			<NotSystemItems>
				<Trans
					i18nKey={ALL_LANG_KEY.offer_spend_crud_modal.title_remove_single}
					components={{ span: <span className={'text-danger'}/> }}
				/>:
				<br/>
				<br/>
				<ItemBox key={`offer-spend-${item?.id}`}
					// className={'text-danger'}
				>
					- <IdBox className={'text-danger'}>[id: {item?.id}]</IdBox> {itemLabel}
				</ItemBox>
			</NotSystemItems>
		)
	}

	const modalTitle = (
		<Trans
			i18nKey={ALL_LANG_KEY.offer_spend_crud_modal.title_remove_single}
			components={{ span: <></> }}
		/>
	)
	const modalBody = (
		<>
			{renderSingleItem()}
		</>
	)
	const msgRemoveConfirm = `${t(ALL_LANG_KEY.offer_spend_crud_modal.msg_remove_confirm)}`

	return <>
		<Modal show={show}
		       onHide={onClose}
		       scrollable={true}
		       size={'lg'}
		>
			<Modal.Header closeButton>
				<Modal.Title>{modalTitle}</Modal.Title>
			</Modal.Header>

			<Modal.Body>
				<ModalBodyBox className={'fs-25'}>
					{modalBody}
					<span className={'text-primary'}>{msgRemoveConfirm}</span>
				</ModalBodyBox>
			</Modal.Body>

			<Modal.Footer>
				<Button variant="primary" onClick={onRemove}>{`${t(ALL_LANG_KEY.offer_spend_crud_modal.btn_remove)}`}</Button>
				<Button variant="secondary" onClick={onClose}>{`${t(ALL_LANG_KEY.offer_spend_crud_modal.btn_close)}`}</Button>
			</Modal.Footer>
		</Modal>
	</>
}
